import { render, staticRenderFns } from "./recognitionHelp.vue?vue&type=template&id=d280d38c&scoped=true"
import script from "./recognitionHelp.vue?vue&type=script&lang=js"
export * from "./recognitionHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d280d38c",
  null
  
)

export default component.exports